import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { createWidget } from '@alfa-bank/site-util-create-widget';

import { OpenAccountButton as Component } from './component';
import type { IDepsDesktop, TOpenAccountButtonDesktop } from './models';

export const OpenAccountButtonDesktop = createWidget<IDepsDesktop, TOpenAccountButtonDesktop>({
    Button,
})(Component);
